import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteTipoFiscalPipe, ClienteTipoFiscalDescricaoPipe } from './pipes';
import { ClienteTipoFiscalMultiselectComponent } from './multiselect';
import { ClienteTipoFiscalSelectComponent } from './select';


@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        // Components
        ClienteTipoFiscalMultiselectComponent,
        ClienteTipoFiscalSelectComponent,

        // Pipes
        ClienteTipoFiscalPipe,
        ClienteTipoFiscalDescricaoPipe
    ],
    exports: [
        // Components
        ClienteTipoFiscalMultiselectComponent,
        ClienteTipoFiscalSelectComponent,

        // Pipes
        ClienteTipoFiscalPipe,
        ClienteTipoFiscalDescricaoPipe
    ],
    providers: [
        ClienteTipoFiscalPipe,
        ClienteTipoFiscalDescricaoPipe
    ]
})
export class ClienteTipoFiscalModule { }
